import React from 'react';
import type { ContactCardProps } from './ContactCards';

const ContactCard: React.FC<ContactCardProps> = ({
  title,
  description,
  link,
  href,
  icon,
}) => (
  <div className="p-4 md:p-6">
    <div className="mb-4 md:mb-8">{icon}</div>

    <div>
      <h4 className="text-base md:text-lg font-bold text-primary">{title}</h4>
      <p className="text-secondary mb-4 mt-2">{description}</p>
      <a href={href} className="text-primary underline">
        {link}
      </a>
    </div>
  </div>
);

export default ContactCard;
